(function () {
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-mt-count]');
    if (!els.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          var el = entry.target;
          var target = parseFloat(el.getAttribute('data-mt-count')) || 0;
          var suffix = el.getAttribute('data-mt-suffix') || '';
          var duration = 1200;
          var start = null;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.round(target * eased) + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initFaq() {
    var items = document.querySelectorAll('.mt-faq-item');
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector('.mt-faq-question');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  function initPdpGallery() {
    var wraps = document.querySelectorAll('[data-mt-pdp-gallery]');
    wraps.forEach(function (wrap) {
      var main = wrap.querySelector('[data-mt-pdp-main]');
      var thumbs = wrap.querySelectorAll('[data-mt-pdp-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-mt-pdp-thumb');
          main.setAttribute('src', src);
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initPdpVariants() {
    var forms = document.querySelectorAll('[data-mt-pdp-form]');
    forms.forEach(function (formWrap) {
      var dataEl = formWrap.querySelector('[data-mt-variants-json]');
      if (!dataEl) return;
      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var idInput = formWrap.querySelector('input[name="id"]');
      var priceEl = formWrap.querySelector('[data-mt-price]');
      var compareEl = formWrap.querySelector('[data-mt-price-compare]');
      var buyBtn = formWrap.querySelector('[data-mt-buy-btn]');
      var optionButtons = formWrap.querySelectorAll('[data-mt-option-value]');
      var selected = {};

      optionButtons.forEach(function (btn) {
        if (btn.classList.contains('is-selected')) {
          selected[btn.getAttribute('data-mt-option-index')] = btn.getAttribute('data-mt-option-value');
        }
      });

      function money(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function updateVariant() {
        var match = variants.find(function (v) {
          return Object.keys(selected).every(function (idx) {
            return String(v.options[idx]) === selected[idx];
          });
        });
        if (!match) return;
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = money(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (buyBtn) {
          if (match.available) {
            buyBtn.removeAttribute('disabled');
            buyBtn.textContent = buyBtn.getAttribute('data-mt-label-available') || 'Add to cart';
          } else {
            buyBtn.setAttribute('disabled', 'disabled');
            buyBtn.textContent = buyBtn.getAttribute('data-mt-label-sold-out') || 'Sold out';
          }
        }
      }

      optionButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.getAttribute('data-mt-option-index');
          var group = formWrap.querySelectorAll('[data-mt-option-index="' + idx + '"]');
          group.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          selected[idx] = btn.getAttribute('data-mt-option-value');
          updateVariant();
        });
      });
    });
  }

  function initBuildStack() {
    var wraps = document.querySelectorAll('[data-mt-build-stack]');
    wraps.forEach(function (wrap) {
      var cards = wrap.querySelectorAll('[data-mt-stack-item]');
      var countEl = wrap.querySelector('[data-mt-stack-count]');
      var totalEl = wrap.querySelector('[data-mt-stack-total]');
      var addBtn = wrap.querySelector('[data-mt-stack-add]');
      if (!cards.length || !addBtn) return;

      function money(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function update() {
        var selected = wrap.querySelectorAll('[data-mt-stack-item].is-selected');
        var total = 0;
        selected.forEach(function (c) { total += parseInt(c.getAttribute('data-price'), 10) || 0; });
        countEl.textContent = selected.length + (selected.length === 1 ? ' selected' : ' selected');
        totalEl.textContent = money(total);
        if (selected.length > 0) {
          addBtn.removeAttribute('disabled');
        } else {
          addBtn.setAttribute('disabled', 'disabled');
        }
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          card.classList.toggle('is-selected');
          update();
        });
      });

      addBtn.addEventListener('click', function () {
        var selected = wrap.querySelectorAll('[data-mt-stack-item].is-selected');
        if (!selected.length) return;
        var items = Array.prototype.map.call(selected, function (c) {
          return { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 };
        });
        addBtn.setAttribute('disabled', 'disabled');
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart add failed');
            return res.json();
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            addBtn.textContent = originalText;
            addBtn.removeAttribute('disabled');
            alert('Something went wrong adding your stack. Please try again.');
          });
      });

      update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initFaq();
    initPdpGallery();
    initPdpVariants();
    initBuildStack();
  });
})();
